import { AskUserQuestionTool } from '#plugin-chat/components/tools/ask-user-question/AskUserQuestionTool.tsx';
import { DescribeViewsTool } from '#plugin-chat/components/tools/describe-views/DescribeViewsTool.tsx';
import { FetchTimeseriesDatapointsTool } from '#plugin-chat/components/tools/fetch-timeseries-datapoints/FetchTimeseriesDatapointsTool.tsx';
import { JoinDatasetsTool } from '#plugin-chat/components/tools/join-datasets/JoinDatasetsTool.tsx';
import { PlanTool } from '#plugin-chat/components/tools/plan/PlanTool.tsx';
import { QueryKnowledgeGraphTool } from '#plugin-chat/components/tools/query-knowledge-graph/QueryKnowledgeGraphTool.tsx';
import { RegisterDatasetTool } from '#plugin-chat/components/tools/register-dataset/RegisterDatasetTool.tsx';
import { ShowDashboardTool } from '#plugin-chat/components/tools/show-dashboard/ShowDashboardTool.tsx';
import { TransformDatasetTool } from '#plugin-chat/components/tools/transform-dataset/TransformDatasetTool.tsx';

/** Aggregated namespace of tool UI components for rendering LLM tool invocations in the chat interface. */
export const Tool = {
  AskUserQuestion: AskUserQuestionTool,
  DescribeViews: DescribeViewsTool,
  FetchTimeseriesDatapoints: FetchTimeseriesDatapointsTool,
  ShowDashboard: ShowDashboardTool,
  JoinDatasets: JoinDatasetsTool,
  Plan: PlanTool,
  TransformDataset: TransformDatasetTool,
  QueryKnowledgeGraph: QueryKnowledgeGraphTool,
  RegisterDataset: RegisterDatasetTool,
};
